/**
 * Shared Azure blob-container SAS from API responses (`mediaSasToken`).
 * Media URLs are returned bare; hydrate before rendering images.
 */

let mediaSasToken = null;

/** `image` is Stream Chat's user avatar field on reaction / member payloads. */
const MEDIA_URL_KEYS = new Set([
  'avatarUrl',
  'coverBannerUrl',
  'coverImageUrl',
  'imageUrl',
  'image',
]);

const isAzureBlobUrl = (url) => typeof url === 'string' && url.includes('blob.core.windows.net');

export const setMediaSasToken = (token) => {
  if (typeof token === 'string' && token.trim()) {
    mediaSasToken = token.startsWith('?') ? token.slice(1) : token.trim();
  }
};

export const getMediaSasToken = () => mediaSasToken;

export const clearMediaSasToken = () => {
  mediaSasToken = null;
};

const stripQuery = (url) => {
  if (typeof url !== 'string' || !url) {
    return url;
  }
  const idx = url.indexOf('?');
  return idx === -1 ? url : url.slice(0, idx);
};

export const resolveMediaUrl = (url, token = mediaSasToken) => {
  if (!url || typeof url !== 'string') {
    return url;
  }
  if (!token || !isAzureBlobUrl(url)) {
    return url;
  }
  if (url.includes('sig=') || url.includes('sp=')) {
    return url;
  }
  return `${stripQuery(url)}?${token}`;
};

export const hydrateMediaUrls = (value, token = mediaSasToken) => {
  if (!value || !token) {
    return value;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => hydrateMediaUrls(item, token));
    return value;
  }
  if (typeof value !== 'object') {
    return value;
  }
  for (const key of Object.keys(value)) {
    const child = value[key];
    if (MEDIA_URL_KEYS.has(key) && typeof child === 'string') {
      value[key] = resolveMediaUrl(child, token);
    } else if (child && typeof child === 'object') {
      hydrateMediaUrls(child, token);
    }
  }
  return value;
};

export const applyMediaSasFromResponseData = (data) => {
  if (!data || typeof data !== 'object') {
    return data;
  }
  if (typeof data.mediaSasToken === 'string') {
    setMediaSasToken(data.mediaSasToken);
  }
  hydrateMediaUrls(data, getMediaSasToken());
  return data;
};
